import * as actions from './actions';
import { ReviewService } from "services";
import { basicEpic } from "redux/ducks/helpers";
import { ofType } from "redux-observable";
import { mergeMap } from "rxjs/operators";
import { CREATE_SESSION_SUCCESS, RELOAD_SESSION_SUCCESS } from '../Session';
import { of } from 'rxjs/observable/of';

export const fetchReviewsEpic = basicEpic(
  actions.FETCH_REVIEWS,
  (_, state) => {
    return new ReviewService(state.session).getAll();
  }
);

export const evaluateReviewEpic = basicEpic(
  actions.EVALUATE_REVIEW,
  (payload, state) => {
    return new ReviewService(state.session).update(payload)
      .then(() => {
        return payload;
      });
  }
);

export const triggerLogin = (action$, store) => {
  return action$.pipe(
    ofType(RELOAD_SESSION_SUCCESS, CREATE_SESSION_SUCCESS),
    mergeMap(() => of({ type: actions.FETCH_REVIEWS }))
  );
};
